// ============================================================================
//  CONTENU DE L'ARTICLE — MODIFIEZ ICI / EDIT YOUR CONTENT HERE
//  Tout le texte (FR + EN) et les images sont centralisés dans ce fichier.
//  All text (FR + EN) and images live in this single file.
// ============================================================================

// Photos réelles Whitlock16 fournies par le client.
const A = "https://customer-assets-eiarnc6j.emergentagent.net/job_multi-langue/artifacts";
export const IMAGES = {
  hero: `${A}/1fatl5lo_w16aparthotel.webp`,
  officeDistrict: "https://images.pexels.com/photos/6791897/pexels-photo-6791897.jpeg?auto=compress&cs=tinysrgb&w=1400",
  bandeau: `${A}/kni3udsa_Photo%20-%20Drone%20-%20003.webp`,
  areaMontgomery: `${A}/kni3udsa_Photo%20-%20Drone%20-%20003.webp`,
  areaLeopold: `${A}/6l12rkpn_unnamed.jpg`,
  areaEtterbeek: `${A}/l1mlqm0v_cinquantenaire-park.jpg`,
  studioMain: `${A}/mlgyfgmp_Photo%20-%20Superior%20Studio%20with%20Balcony%20-%20001.webp`,
  studioKitchen: `${A}/9ayfgehb_Photo%20-%20Deluxe%20Studio%20-%20026.webp`,
  studioBath: `${A}/8j237sak_Photo%20-%20Deluxe%20Studio%20-%20020.webp`,
  garden: `${A}/5prpzz91_Photo%20-%20Exteriors%20-%20016.webp`,
  matterFlex: `${A}/3jjb0ajb_Photo%20-%20Cafeteria%20-%20001.webp`,
  matterWork: `${A}/cyhvqthd_Photo%20-%20Premium%20Studio%201st%20Floor%20with%20Terrace%20-%20001.webp`,
  matterQuiet: `${A}/v42d5m2i_Photo%20-%20Deluxe%20Studio%20With%20Terrace%20-%20027.webp`,
  schoolMontgomery: `${A}/4x78i0ba_montgom%20500x500px.jpg`,
  schoolIchec: `${A}/0czqx8kq_Capture%20d%E2%80%99e%CC%81cran%202026-07-30%20a%CC%80%2021.30.30.png`,
};

export const MARQUEE = [
  "WHITLOCK16",
  "BOULEVARD BRAND WHITLOCK",
  "BRUXELLES · 1200",
  "QUARTIER EUROPÉEN",
  "MONTGOMERY",
];

export const UI = {
  fr: {
    langLabel: "FR",
    brand: "WHITLOCK16",
    scroll: "Défiler",
    tocLabel: "L'article",
    bookCta: "Réserver en direct",
    codeLabel: "Code",
    footerNote: "Se loger près du quartier européen — en version résidentielle.",
    footerAddress: "16, boulevard Brand Whitlock · 1200 Bruxelles",
    gardenCaption: "Le jardin privatif et la terrasse — une respiration au cœur du quartier.",
  },
  en: {
    langLabel: "EN",
    brand: "WHITLOCK16",
    scroll: "Scroll",
    tocLabel: "The article",
    bookCta: "Book directly",
    codeLabel: "Code",
    footerNote: "Staying near the European Quarter — the residential version.",
    footerAddress: "16 boulevard Brand Whitlock · 1200 Brussels",
    gardenCaption: "The private garden and terrace — a breath of air in the heart of the neighbourhood.",
  },
};

export const ARTICLE = {
  fr: {
    eyebrow: "Se loger à Bruxelles",
    title: "Se loger près du quartier européen à Bruxelles",
    subtitle:
      "Commission, Parlement, Conseil : quel quartier choisir quand on vient travailler avec les institutions européennes.",
    byline: "Le guide Whitlock16",
    location: "Bruxelles · Quartier européen",
    readingTime: "6 min de lecture",
    lede:
      "Vous arrivez à Bruxelles pour travailler avec les institutions européennes, et il faut bien poser ses valises quelque part. Le réflexe : viser Schuman, au pied du Berlaymont. C'est rarement le bon choix — et il vaut la peine de comprendre pourquoi avant de réserver.",
    chapters: [
      {
        n: "01",
        heading: "Le quartier européen n'est pas un quartier résidentiel",
        paragraphs: [
          "Le cœur institutionnel de Bruxelles — le rond-point Schuman, la rue de la Loi, l'esplanade du Parlement — est avant tout un quartier de bureaux. En semaine, à l'heure du déjeuner, il bat son plein : dense, pressé, saturé de badges et de costumes.",
          "Mais dès le soir tombé, et tout le week-end, il se vide presque entièrement. Peu de commerces de proximité, peu de vie de quartier, une architecture de verre et de béton, une circulation continue sur les grands axes. Pour une réunion d'une journée, l'emplacement est imbattable. Pour une semaine, un mois, un semestre, ceux qui y ont séjourné vous diront tous la même chose : c'est fonctionnel, mais on n'y vit pas.",
        ],
      },
      {
        n: "02",
        heading: "La bonne équation : proche sans être dedans",
        paragraphs: [
          "Les habitués du circuit bruxellois — consultants, représentants permanents, cadres en détachement — finissent presque tous par adopter la même stratégie : loger dans un quartier résidentiel voisin, à quelques minutes des institutions, mais où l'on retrouve des arbres, une boulangerie au coin de la rue, un parc, et le silence la nuit.",
          "Trois zones répondent à ce cahier des charges, chacune avec son tempérament.",
        ],
      },
    ],
    areas: [
      {
        name: "Montgomery & boulevard Brand Whitlock",
        text: "À l'est du Cinquantenaire, autour du square Montgomery, on bascule dans un Bruxelles résidentiel et arboré — celui des larges avenues plantées qui ont fait la réputation de la ville. Calme, parfaitement desservi, à portée immédiate des institutions en métro comme à pied par le parc. Un équilibre rare entre proximité professionnelle et qualité de vie.",
      },
      {
        name: "Le quartier Léopold & les Squares",
        text: "Autour des squares Marie-Louise et Ambiorix, l'atmosphère change encore : maisons de maître, étangs, façades Art nouveau. Superbe, très prisé — et, forcément, plutôt cher à la location.",
      },
      {
        name: "Etterbeek & le Cinquantenaire",
        text: "Au sud du parc, un quartier plus mélangé, étudiant par endroits, au bon rapport qualité-prix et à la vie de quartier bien réelle.",
      },
    ],
    bandeauCaption:
      "Boulevard Brand Whitlock : l'architecture résidentielle bruxelloise, à quelques minutes des institutions.",
    pullQuote:
      "Du bon côté du Cinquantenaire — celui où l'on entend les oiseaux plutôt que la rue de la Loi.",
    travel: {
      heading: "Combien de temps pour rejoindre les institutions ?",
      intro:
        "Depuis le boulevard Brand Whitlock, les principaux lieux de travail européens sont tous à portée rapide : à pied par le Cinquantenaire, ou en métro depuis Montgomery (lignes 1 et 5). Les durées ci-dessous sont des estimations porte-à-porte, à affiner selon l'heure et le pas de chacun.",
      cols: ["Destination", "À pied", "En métro"],
      rows: [
        ["Commission européenne (Berlaymont)", "≈ 20 min", "≈ 12 min"],
        ["Parlement européen", "≈ 30 min", "≈ 18 min"],
        ["Conseil de l'Union européenne", "≈ 22 min", "≈ 13 min"],
        ["Grand-Place / centre-ville", "≈ 40 min", "≈ 20 min"],
      ],
    },
    stay: {
      heading: "Loger au Whitlock16 : le quartier européen, en version résidentielle",
      paragraphs: [
        "Le Whitlock16 occupe le 16, boulevard Brand Whitlock, à 1200 Bruxelles — précisément sur cette ligne de crête : à quelques minutes des institutions, mais du bon côté du Cinquantenaire.",
        "Nos onze studios, de 17 à 51 m², disposent tous d'une cuisine équipée et d'un véritable espace de travail. Ils conviennent aussi bien à une mission de trois nuits qu'à un détachement de plusieurs mois. Certains ouvrent sur une terrasse ou un balcon, d'autres sur le jardin privatif. L'accès se fait par code personnel et clé numérique, sans contrainte d'horaire — un détail qui compte quand une réunion s'achève à vingt-deux heures ou qu'un vol se pose à minuit.",
      ],
      nearbyHeading: "À moins de 100 m",
      nearbyNote: "Un atout de taille pour les familles en mobilité comme pour les séjours académiques.",
      nearby: ["Montgomery International School", "ICHEC Brussels Management School"],
    },
    matters: {
      heading: "Ce qui compte vraiment quand on travaille avec les institutions",
      intro: "Au-delà de la distance, trois critères reviennent systématiquement chez nos clients institutionnels.",
      items: [
        {
          n: "01",
          title: "La flexibilité des dates",
          text: "Les calendriers européens sont vivants : une session se prolonge, une réunion se déplace. Pouvoir ajuster son séjour vaut mieux qu'un tarif un peu plus bas.",
        },
        {
          n: "02",
          title: "Travailler depuis son logement",
          text: "Une connexion fiable et un vrai bureau — pas un guéridon. Une grande partie du travail se fait le soir, dans la chambre.",
        },
        {
          n: "03",
          title: "Le calme",
          text: "Le critère le plus sous-estimé, et celui qui décide le plus de la réussite d'une mission longue.",
        },
      ],
    },
    booking: {
      heading: "Réserver",
      text: "En réservant en direct, vous profitez de 10 % de réduction avec le code DBW16. Pour un séjour de plusieurs semaines ou un dossier corporate, écrivez-nous : nous établissons une proposition sur mesure.",
      code: "DBW16",
      discount: "-10 %",
    },
    faq: {
      heading: "Questions fréquentes",
      items: [
        {
          q: "Vaut-il mieux loger à Schuman même ?",
          a: "Pour une nuit avant une réunion matinale, oui. Au-delà, un quartier résidentiel voisin offre un bien meilleur cadre de vie pour un temps de trajet à peine supérieur.",
        },
        {
          q: "Le quartier est-il sûr le soir ?",
          a: "Le boulevard Brand Whitlock et les abords de Montgomery forment un quartier résidentiel calme, éclairé et fréquenté — l'un des plus paisibles de Bruxelles.",
        },
        {
          q: "Peut-on se passer de voiture ?",
          a: "Sans difficulté. Métro (lignes 1 et 5 à Montgomery), trams (7 et 25 sur le boulevard) et bus desservent le quartier, et une bonne partie du quartier européen se rejoint à pied par le Cinquantenaire.",
        },
        {
          q: "Y a-t-il un parking ?",
          a: "Oui. Des emplacements privés couverts et payants sont disponibles à moins de 100 m, sur demande. Un stationnement en voirie, en zone réglementée, reste également possible aux alentours.",
        },
      ],
    },
  },

  en: {
    eyebrow: "Staying in Brussels",
    title: "Where to stay near the European Quarter in Brussels",
    subtitle:
      "Commission, Parliament, Council: which neighbourhood to choose when you come to Brussels to work with the European institutions.",
    byline: "The Whitlock16 guide",
    location: "Brussels · European Quarter",
    readingTime: "6 min read",
    lede:
      "You're arriving in Brussels to work with the European institutions, and you need somewhere to set down your bags. The instinct is to aim for Schuman, right at the foot of the Berlaymont. It's rarely the best choice — and it's worth understanding why before you book.",
    chapters: [
      {
        n: "01",
        heading: "The European Quarter is not a residential neighbourhood",
        paragraphs: [
          "The institutional heart of Brussels — the Schuman roundabout, the rue de la Loi, the Parliament esplanade — is first and foremost an office district. At lunchtime on a weekday it's in full swing: dense, hurried, a sea of lanyards and suits.",
          "But once evening falls, and all weekend, it empties almost completely. Few local shops, little neighbourhood life, glass-and-concrete architecture, unrelenting traffic on the main arteries. For a one-day meeting, the location is unbeatable. For a week, a month, a semester, everyone who has stayed there will tell you the same thing: it's functional, but you don't really live there.",
        ],
      },
      {
        n: "02",
        heading: "The right balance: close without being inside",
        paragraphs: [
          "Regulars on the Brussels circuit — consultants, permanent representatives, seconded staff — almost all settle on the same strategy: stay in a neighbouring residential district, a few minutes from the institutions, but where there are trees, a bakery on the corner, a park, and quiet at night.",
          "Three areas fit that brief, each with its own character.",
        ],
      },
    ],
    areas: [
      {
        name: "Montgomery & boulevard Brand Whitlock",
        text: "East of the Cinquantenaire, around Montgomery square, you cross into a residential, tree-lined Brussels — the one of broad planted avenues that made the city's name. Quiet, superbly served, within immediate reach of the institutions by metro or on foot through the park. A rare balance between professional proximity and quality of life.",
      },
      {
        name: "The Leopold Quarter & the Squares",
        text: "Around Marie-Louise and Ambiorix squares the mood shifts again: townhouses, ponds, Art Nouveau façades. Gorgeous, much in demand — and, inevitably, expensive to rent.",
      },
      {
        name: "Etterbeek & the Cinquantenaire",
        text: "South of the park, a more mixed neighbourhood, student in places, with good value for money and real, lived-in local life.",
      },
    ],
    bandeauCaption:
      "Boulevard Brand Whitlock: residential Brussels architecture, minutes from the institutions.",
    pullQuote:
      "On the right side of the Cinquantenaire — the side where you hear birdsong rather than the rue de la Loi.",
    travel: {
      heading: "How long does it take to reach the institutions?",
      intro:
        "From boulevard Brand Whitlock, the main European workplaces are all quickly reachable — on foot through the Cinquantenaire, or by metro from Montgomery (lines 1 and 5). The times below are door-to-door estimates, to be fine-tuned for the hour and your own pace.",
      cols: ["Destination", "On foot", "By metro"],
      rows: [
        ["European Commission (Berlaymont)", "≈ 20 min", "≈ 12 min"],
        ["European Parliament", "≈ 30 min", "≈ 18 min"],
        ["Council of the European Union", "≈ 22 min", "≈ 13 min"],
        ["Grand-Place / city centre", "≈ 40 min", "≈ 20 min"],
      ],
    },
    stay: {
      heading: "Staying at Whitlock16: the European Quarter, residential version",
      paragraphs: [
        "Whitlock16 sits at 16 boulevard Brand Whitlock, 1200 Brussels — right on that ridge line: minutes from the institutions, but on the right side of the Cinquantenaire.",
        "Our eleven studios, from 17 to 51 m², all come with a fitted kitchen and a proper work space. They suit a three-night assignment as easily as a secondment of several months. Some open onto a terrace or balcony, others onto the private garden. Access is by personal code and digital key, with no time constraint — a detail that matters when a meeting wraps at ten in the evening or a flight lands at midnight.",
      ],
      nearbyHeading: "Under 100 m away",
      nearbyNote: "A real plus for relocating families and academic stays alike.",
      nearby: ["Montgomery International School", "ICHEC Brussels Management School"],
    },
    matters: {
      heading: "What really matters when you work with the institutions",
      intro: "Beyond distance, three criteria come up again and again with our institutional guests.",
      items: [
        {
          n: "01",
          title: "Flexible dates",
          text: "European calendars are alive: a session runs on, a meeting shifts. Being able to adjust your stay is worth more than a marginally lower rate.",
        },
        {
          n: "02",
          title: "Working from where you stay",
          text: "A reliable connection and a real desk — not a side table. A good deal of the work happens in the evening, in the room.",
        },
        {
          n: "03",
          title: "Quiet",
          text: "The most underestimated criterion, and the one that most determines the success of a long assignment.",
        },
      ],
    },
    booking: {
      heading: "Booking",
      text: "Book directly and enjoy 10% off with the code DBW16. For a stay of several weeks or a corporate account, write to us and we'll prepare a tailored proposal.",
      code: "DBW16",
      discount: "-10%",
    },
    faq: {
      heading: "Frequently asked questions",
      items: [
        {
          q: "Is it better to stay in Schuman itself?",
          a: "For one night before an early meeting, yes. Beyond that, a neighbouring residential district offers a far better setting for barely any extra travel time.",
        },
        {
          q: "Is the neighbourhood safe in the evening?",
          a: "Boulevard Brand Whitlock and the area around Montgomery form a quiet, well-lit and well-used residential district — one of the most peaceful parts of Brussels.",
        },
        {
          q: "Can I manage without a car?",
          a: "Easily. Metro (lines 1 and 5 at Montgomery), trams (7 and 25 on the boulevard) and buses serve the neighbourhood, and much of the European Quarter is walkable through the Cinquantenaire.",
        },
        {
          q: "Is there parking?",
          a: "Yes. Private covered paid parking spaces are available under 100 m away, on request. On-street parking, in a regulated zone, is also available nearby.",
        },
      ],
    },
  },
};
